import { render, staticRenderFns } from "./no-data-text.vue?vue&type=template&id=77e32f6d&scoped=true"
import script from "./no-data-text.vue?vue&type=script&lang=js"
export * from "./no-data-text.vue?vue&type=script&lang=js"
import style0 from "./no-data-text.vue?vue&type=style&index=0&id=77e32f6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e32f6d",
  null
  
)

export default component.exports